/** Slice of the v2 `user.features` map; values are `"on"` / `"off"`. */
export interface StaffFeatures {
  is_staff?: string | undefined;
  is_impersonated?: string | undefined;
}

export const isStaffOrImpersonated = (
  features: StaffFeatures | undefined,
): boolean => features?.is_staff === "on" || features?.is_impersonated === "on";
